import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function ProblemSection() {
  const painPoints = ['El problema sin sistema', 'Horas en YouTube sin aprender nada concreto', 'Excel que da miedo abrir', 'Sin saber cómo escribir un mail profesional', 'Sin saber cuánto cobrar ni cómo buscar clientes', 'Sintiéndote "demasiado grande" para aprender'];
  return <section className="bg-night py-12" data-id="element-245">
      <div className="max-w-4xl mx-auto px-6" data-id="element-246">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8" data-id="element-247">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 leading-tight" data-id="element-248">
            ¿Cuántos días más vas a sentir que la tecnología no es para vos?
          </h2>
          <div className="text-lg text-textLight space-y-4 max-w-2xl mx-auto" data-id="element-249">
            <p data-id="element-250">
              Querés trabajar desde casa. Sabés que tenés capacidad. Pero cada
              vez que intentás aprender algo nuevo aparece esa voz:
            </p>
            <p className="font-serif italic text-xl text-gold-accent font-medium" data-id="element-251">
              "¿Y si no puedo? ¿Y si soy muy grande para esto?"
            </p>
            <p data-id="element-252">
              No es falta de inteligencia. No es la edad. Es falta de un sistema
              diseñado para vos.
            </p>
          </div>
        </motion.div>

        <div className="glass rounded-2xl p-8 max-w-3xl mx-auto" data-id="element-253">
          <ul className="space-y-4" data-id="element-254">
            {painPoints.map((point, idx) => <motion.li key={idx} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: idx * 0.1
          }} className="flex items-start gap-3" data-id="element-255">
                <div className="mt-1 bg-red-500/20 p-1 rounded-full flex-shrink-0 border border-red-500/30" data-id="element-256">
                  <X className="w-4 h-4 text-red-400" data-id="element-257" />
                </div>
                <span className="text-white font-medium text-lg" data-id="element-258">{point}</span>
              </motion.li>)}
          </ul>
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-center mt-8" data-id="element-259">
          <p className="text-2xl font-bold text-gold-accent" data-id="element-260">
            ¿Y si esta fuera la última semana que pasás así?
          </p>
        </motion.div>
      </div>
    </section>;
}